/** @typedef {'development' | 'test' | 'production'} environments */
/** @typedef {{ API_BASE_URL: string }} envConfig */

const DEFAULT_API_BASE_URLS = {
  development: "http://localhost:9000/api",
  test: "https://test.contractorwallet.in/api",
  production: "https://app.contractorwallet.in/api",
};

const viteEnv = typeof import.meta === "undefined" ? undefined : import.meta.env;
const nodeEnv = typeof process === "undefined" ? undefined : process.env;

/** @type { environments } */
const env = viteEnv?.VITE_ENV || nodeEnv?.VITE_ENV || "development";

/** @type {envConfig} */
export const envConfig = {
  API_BASE_URL: viteEnv?.VITE_API_BASE_URL || nodeEnv?.VITE_API_BASE_URL || DEFAULT_API_BASE_URLS[env],
};

console.log(`App is working in ${env} environment.`);
console.log(`envConfig - `, envConfig);
